import BreadcrumbTwo from "../../../components/Breadcrumbs/BreadcrumbTwo";
import ProductTable from "../../../components/Catalog/items/ProductTable";
import DefaultLayout from "../../../layout/DefaultLayout";

const ItemPage = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <ProductTable />
    </DefaultLayout>
  );
};

export default ItemPage;
